import React from "react";
import { Search, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export function SearchInput({ value, onChange, placeholder = "Search...", testId = "search-input" }) {
  return (
    <div className="relative w-full max-w-xs">
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <input
        data-testid={testId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="h-9 w-full rounded-lg border border-white/[0.1] bg-[#0A0A0A] pl-9 pr-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus:border-white/30 focus:outline-none focus:ring-1 focus:ring-white/20"
      />
    </div>
  );
}

export function FilterSelect({ value, onChange, options, placeholder, testId }) {
  return (
    <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
      <SelectTrigger
        data-testid={testId}
        className="h-9 w-[150px] border-white/[0.1] bg-[#0A0A0A] text-sm focus:ring-white/20"
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="border-white/[0.1] bg-[#1a1a1e]">
        <SelectItem value="all">All {placeholder}</SelectItem>
        {options.map((o) => {
          const val = typeof o === "string" ? o : o.value;
          const lab = typeof o === "string" ? o : o.label;
          return (
            <SelectItem key={val} value={val} className="capitalize">
              {lab}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}

export function Toolbar({ search, onSearch, searchPlaceholder, filters, onAdd, addLabel, addTestId }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex flex-wrap items-center gap-2">
        {onSearch && <SearchInput value={search} onChange={onSearch} placeholder={searchPlaceholder} />}
        {filters}
      </div>
      {onAdd && (
        <Button
          onClick={onAdd}
          data-testid={addTestId}
          className="h-9 gap-1.5 rounded-lg bg-white text-black hover:bg-white/90"
        >
          <Plus className="h-4 w-4" /> {addLabel}
        </Button>
      )}
    </div>
  );
}
